var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bar-chart-instance',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions,"height":280},on:{"update:chartData":function($event){_vm.chartData=$event},"update:chart-data":function($event){_vm.chartData=$event},"update:options":function($event){_vm.chartOptions=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }